import { useNavigation } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import { If, Then, Else, When } from "react-if";
import {
  ActivityIndicator,
  Animated,
  Image,
  Modal,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";

import AsyncStorage from "@react-native-async-storage/async-storage";

import { MaterialIcons } from "@expo/vector-icons";
import activesService from "../../services/activesService";
import api from "../../services/api";
import { formatGPXBalance, maxDecimals } from "../../utils/formatNumber";
import styles from "./styles";
import { FormattedMessage } from "react-intl";

const CardsMyTokensWallet = ({ saldoGPX, showTradeButtons }) => {
  const [viewScale] = useState(new Animated.Value(600));
  const [selectedAsset, setSelectedAsset] = useState({});
  const [selectedAssetApiObj, setSelectedAssetApiObj] = useState({});
  const [certificateEmit, setCertificateEmit] = useState(false);
  const navigation = useNavigation();
  const [saldo, setSaldo] = useState(0);
  const [listActives, setListActives] = useState([]);
  const [loading, setLoading] = useState(false);
  const [authToken, setAuthToken] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [clientCountry, setClientCountry] = useState("");

  useEffect(() => {
    if (selectedAsset?.id) {
      setCertificateEmit(false);
      getBalanceCoin();
      getSelectedAssetApiInfo(selectedAsset?.id);
    }
  }, [selectedAsset]);

  useEffect(() => {
    getTokensWallet();
  }, [saldoGPX]);

  useEffect(() => {
    getClientCountry();
  }, []);

  const getClientCountry = async () => {
    const country = await AsyncStorage.getItem("client_country");
    setClientCountry(country);
  };

  const getSelectedAssetApiInfo = async (activeId) => {
    try {
      const token = await AsyncStorage.getItem("JWT_TOKEN");

      if (token) {
        const response = await activesService.getById(token, activeId);

        if (response.data) {
          setSelectedAssetApiObj(response.data);

          if (response.data.actives.length > 0) {
            if (response.data.actives[0].certificate) {
              setCertificateEmit(true);
            } else {
              setCertificateEmit(false);
            }
          }
        }
      } else {
        console.error("Token is missing or invalid.");
      }
    } catch (error) {
      console.error("Error fetching selected asset info:", error);
    }
  };

  const getBalanceCoin = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    api
      .get(`balanceGpxcoin/${selectedAsset.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setSaldo(Number(res.data.saldo));
      })
      .catch((error) => {});
  };

  const BalanceInfo = () => (
    <View style={styles.balanceInfo}>
      <Text style={styles.balanceLabel}>
        <FormattedMessage id="cardsmytokenswallet.saldo" />
      </Text>
      <Text style={styles.balanceValue}>
        {maxDecimals(saldo, 8)} {selectedAsset.name_token}
      </Text>
    </View>
  );

  const getTokensWallet = async () => {
    const authToken = await AsyncStorage.getItem("JWT_TOKEN");
    setAuthToken(authToken);

    const clientCountry = await AsyncStorage.getItem("client_country");

    try {
      const response = await activesService.getActivesWhereUserHasBalance(
        authToken
      );

      if (response.data.length > 0) {
        const filteredActives = response.data.filter((active) => {
          const isAdoption = active.adoption === true;
          const isIRec = active.category_name === "I-REC";

          return !isAdoption && !(isIRec && clientCountry !== "brasil");
        });

        setListActives(filteredActives);
      }
    } catch (error) {
      console.error("Error fetching actives:", error);
    }
  };

  function handleSelectedAsset(asset) {
    setModalVisible(true);
    setSelectedAsset(asset);
  }
  return (
    <>
      <If condition={loading}>
        <Then>
          <View style={styles.center}>
            <ActivityIndicator size="large" color="#2797A2" />
          </View>
        </Then>
        <Else>
          <>
            <ScrollView
              contentContainerStyle={styles.scrollViewContent}
              nestedScrollEnabled={true}
            >
              <If condition={listActives !== null}>
                <Then>
                  {listActives.map((item, index) => (
                    <View
                      style={styles.contentItem}
                      onPress={() => handleSelectedAsset(item)}
                      key={index}
                    >
                      <If condition={item.path}>
                        <Then>
                          <Image
                            source={{
                              uri:
                                "https://filesgpx.s3.us-east-2.amazonaws.com/" +
                                item.path,
                            }}
                            style={styles.img}
                          />
                        </Then>
                        <Else>
                          <Image
                            source={require("../../../assets/home/icons/logo.png")}
                            style={styles.img}
                          />
                        </Else>
                      </If>
                      <View style={styles.columnContainer}>
                        <Text style={styles.certificateHeaders}>
                          <FormattedMessage id="cardsMyCertificatesWallet.certHeadAtivo" />
                        </Text>
                        <View style={styles.ativoImgRowContainer}>
                          <Text style={styles.dadosAtivo}>
                            {item.name_token}
                          </Text>
                        </View>
                      </View>

                      <View style={styles.columnContainer}>
                        <Text style={styles.certificateHeaders}>
                          <FormattedMessage id="cardsMyCertificatesWallet.certHeadQuantidade" />
                        </Text>
                        <Text style={styles.priceCoin}>
                          {maxDecimals(item.balance, 0)}
                        </Text>
                      </View>

                      <View style={styles.textsItem}>
                        <View style={styles.infoPrice}>
                          <View style={styles.columnContainer}>
                            <Text style={styles.certificateHeaders}>
                              <FormattedMessage id="cardsmytokenswallet.valor" />
                            </Text>
                            <Text style={styles.priceCoin}>
                              {formatGPXBalance(item.single_value)}
                              <FormattedMessage id="cardsmytokenswallet.gpx" />
                            </Text>
                          </View>
                        </View>
                      </View>
                      <When condition={showTradeButtons}>
                        <TouchableOpacity
                          onPress={() =>
                            navigation.navigate("Purchase", {
                              viewType: "buy",
                              selectedActive: item.id,
                            })
                          }
                          style={styles.btnComprar}
                        >
                          <Text style={styles.btnComprarText}>
                            <FormattedMessage id="tokenReleases.btnComprar" />
                          </Text>
                        </TouchableOpacity>
                      </When>
                      <When
                        condition={
                          showTradeButtons && clientCountry === "brasil"
                        }
                      >
                        <TouchableOpacity
                          onPress={() =>
                            navigation.navigate("Purchase", {
                              viewType: "sell",
                              selectedActive: item.id,
                            })
                          }
                          style={[
                            styles.btnVender,
                            !(
                              showTradeButtons &&
                              clientCountry === "brasil" &&
                              !item.name_token.includes("Selo")
                            )
                              ? styles.btnVenderDisabled
                              : null,
                          ]}
                          disabled={!!item.name_token.includes("Selo")}
                        >
                          <Text
                            style={[
                              styles.btnVenderText,
                              !(
                                showTradeButtons &&
                                clientCountry === "brasil" &&
                                !item.name_token.includes("Selo")
                              )
                                ? styles.btnVenderTxtDisabled
                                : null,
                            ]}
                          >
                            <FormattedMessage id="cardsmytokenswallet.btnVender" />
                          </Text>
                        </TouchableOpacity>
                      </When>
                      <TouchableOpacity
                        onPress={() => handleSelectedAsset(item)}
                        style={styles.btnEmitirCertificado}
                      >
                        <FormattedMessage id="cardsmytokenswallet.btnEmitirCertificado" />
                      </TouchableOpacity>
                    </View>
                  ))}
                </Then>
                <Else>
                  <Text style={styles.titleCoin}>
                    <FormattedMessage id="cardsmytokenswallet.semAtivos" />
                  </Text>
                </Else>
              </If>
            </ScrollView>

            <Modal animationType="fade" transparent visible={modalVisible}>
              <View style={styles.modalOverlay}>
                <View style={styles.modalContainer}>
                  <TouchableOpacity
                    onPress={() => setModalVisible(false)}
                    style={styles.closeIconContainer}
                  >
                    <MaterialIcons name="close" size={24} color="#333" />
                  </TouchableOpacity>

                  <Text style={styles.modalTitle}>
                    <FormattedMessage id="cardsmytokenswallet.title" />
                  </Text>

                  <BalanceInfo />

                  {certificateEmit && (
                    <>
                      <TouchableOpacity
                        style={styles.actionButton}
                        onPress={() => {
                          setModalVisible(false);
                          navigation.navigate({
                            name: "Certificates",
                            params: {
                              ...selectedAsset,
                              isOhterCrypto: true,
                              certType: "compensation",
                            },
                          });
                        }}
                      >
                        <Text style={styles.actionButtonText}>
                          <FormattedMessage id="cardsmytokenswallet.emitirCertificado" />
                        </Text>
                      </TouchableOpacity>

                      <TouchableOpacity
                        style={[
                          styles.actionButton,
                          {
                            marginTop: 12,
                            backgroundColor: "#0A9396",
                          },
                        ]}
                        disabled={false}
                        onPress={() => {
                          setModalVisible(false);
                          navigation.navigate("AssetsOwnership");
                        }}
                      >
                        <Text style={styles.actionButtonText}>
                          <FormattedMessage id="cardsmytokenswallet.certificadoPosse" />
                        </Text>
                      </TouchableOpacity>
                    </>
                  )}
                  <Text style={styles.observationText}>
                    <FormattedMessage id="cardsmytokenswallet.certificadoExplicacao" />
                  </Text>
                </View>
              </View>
            </Modal>
          </>
        </Else>
      </If>
    </>
  );
};

export default CardsMyTokensWallet;
